import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import PermissionDenied from './PermissionDenied';

// Composant de protection des routes admin basiques
export const AdminProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-green-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin-login" replace />;
  }

  return children;
};

// Composant de protection des routes superadmin
export const SuperAdminProtectedRoute = ({ children }) => {
  const { t } = useTranslation();
  const { isAuthenticated, loading, isSuperAdmin } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-green-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin-login" replace />;
  }

  if (!isSuperAdmin()) {
    return (
      <PermissionDenied
        title={t('adminProtectedRoute.superAdminRequiredTitle')}
        message={t('adminProtectedRoute.superAdminRequiredMessage')}
      />
    );
  }

  return children;
};

// Composant de protection avec permission spécifique
export const PermissionProtectedRoute = ({ children, permission }) => {
  const { t } = useTranslation();
  const { isAuthenticated, loading, hasPermission } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-green-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin-login" replace />;
  }

  if (!hasPermission(permission)) {
    return (
      <PermissionDenied 
        title="Permission insuffisante"
        message={`Vous n'avez pas la permission "${permission}" nécessaire pour accéder à cette page.`}
      />
    );
  }

  return children;
}; 